import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class LoggingService {
 
  constructor(private http: HttpClient) {}

  // Log info messages
  logInfo(message: string, data?: any) {
    //  ;
    console.log(`INFO: ${message}`, data);
  }

  // Log warning messages
  logWarn(message: string, data?: any) {
     
    console.warn(`WARN: ${message}`, data);
  }

  // Log error messages
  logError(message: string, error?: any) {
     
    console.error(`ERROR: ${message}`, error);
  }
  logSuccess(message: string, data?: any) {
     
    console.log(`SUCCESS: ${message}`, data);
  }

}